import React from "react";
import { ReactComponent as LogoWhite } from "Assets/Logo/LogoWhite.svg";
import { ReactComponent as LogoBlack } from "Assets/Logo/LogoBlack.svg";
import { Link } from "react-router-dom";
// import { Link } from "@mui/material";


const RenderLogo = ({ type = "black", size = "medium" }) => {
  let sizes = {
    large: "50px",
    medium: "44px",
    small: "38px",
  };

  return (
    <>
      <Link sx={{ zIndex: 1 }} display={"flex"} to="/">
        {type == "black" ? (
          <LogoBlack height={sizes[size]} />
        ) : (
          <LogoWhite height={sizes[size]} />
        )}
      </Link>
    </>
  );
};

export default RenderLogo;
